// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__o4_Ec","container":"Footer_container__Mn8SS"};